import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {UrlDto} from "../item/url.dto";
import {UrlBuilder} from "../item/url.item";
import {WrapperDto} from "../dto/wrapper.dto";
import {LegalDocumentDto} from "../dto/legal-document.dto";

/**
 * Rechtstexte von `core`. Der Endpunkt ist **ohne Anmeldung** erreichbar, deshalb
 * faellt der `Acc-Api`-Kopf weg — genau wie in `login`.
 */
@Injectable({providedIn: 'root'})
export class LegalRepo {

  private readonly legalRead: string = '/v1/legal/{document}';
  private readonly legalReadVersion: string = '/v1/legal/{document}/v{version}';

  private readonly http: HttpClient = inject(HttpClient);

  /** Die geltende Fassung. */
  public getInForce(document: string): Observable<WrapperDto<LegalDocumentDto>> {
    const url: UrlDto = UrlBuilder.builder()
      .addPath(this.legalRead)
      .addParam('document', document)
      .deleteHttpHeader(UrlBuilder.API_HEADER)
      .build();
    return this.http.get<WrapperDto<LegalDocumentDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  /** Eine bestimmte, bereits veroeffentlichte Fassung — auch eine abgeloeste. */
  public getByVersion(document: string, version: number): Observable<WrapperDto<LegalDocumentDto>> {
    const url: UrlDto = UrlBuilder.builder()
      .addPath(this.legalReadVersion)
      .addParam('document', document)
      .addParam('version', String(version))
      .deleteHttpHeader(UrlBuilder.API_HEADER)
      .build();
    return this.http.get<WrapperDto<LegalDocumentDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }
}
